import CustomTextArea from '../../../../v2-components/Antd/TextArea';
import { STATUS_DICTIONARY } from '../constants/status-dictionary.constant';
import { isStringEqual } from './is-string-equal.handle';

export const defaultValueTextArea = (status, claimResponse) => {
	if (status === STATUS_DICTIONARY.close && isStringEqual(claimResponse) === false) {
		return (
			<>
				<span>Comentarios</span>
				<CustomTextArea defaultValue={claimResponse} disabled />
			</>
		);
	}

	return null;
};
